import { render, staticRenderFns } from "./MdTablePaginationClient.vue?vue&type=template&id=642fd3a9&scoped=true&"
import script from "./MdTablePaginationClient.vue?vue&type=script&lang=js&"
export * from "./MdTablePaginationClient.vue?vue&type=script&lang=js&"
import style0 from "./MdTablePaginationClient.vue?vue&type=style&index=0&id=642fd3a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642fd3a9",
  null
  
)

export default component.exports